export const SUCESSO_RESGATE = 'Resgate de Assinatura Presente feito com sucesso!'
